import DynamicPaperRouter from "./components/dynamicPaperRouter/DynamicPaperRouter.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Experience from "./pages/experience/experience.jsx";
import Research from "./pages/research/research";
import Contact from "./pages/contact/contact";
import Landing from "./pages/landing/landing";
import About from "./pages/about/about";

import ScrollToTop from "./components/scrollTop/ScrollTop";
import Footer from "./components/footer/Footer";
import { Navbar } from "./components";

import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Navbar />

      <Routes>
        <Route path="/papers/:slug" element={<DynamicPaperRouter />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/research" element={<Research />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/" element={<Landing />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;